function initLeasingModal() {
  const modal = document.getElementById('modal_pop_up_zFhQRL')
             || document.getElementById('modal-pop_up_zFhQRL');
  if (!modal) return;

  const toggle = () => {
    if (modal.hasAttribute('open')) {
      modal.removeAttribute('aria-hidden');
      modal.removeAttribute('inert');
    } else {
      modal.setAttribute('aria-hidden', 'true');
      modal.setAttribute('inert', '');
    }
  };

  toggle();                                   // Initialzustand
  new MutationObserver(toggle)
    .observe(modal, { attributeFilter: ['open'] });
}

/* feuern – egal, wann das Script kommt */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLeasingModal);
} else {
  initLeasingModal();
}